import React from 'react'
import styled from '@emotion/styled'
import { Form, Input, InputNumber, Icon, Checkbox, Tooltip } from 'antd'
import {
  FULL_SCAN_ROOT_URL_FIELD,
  FULL_SCAN_COUNT_FIELD,
  ALL_SUB_DOMAINS_FIELD,
  SCAN_PARAMETERS_FLAG_FIELD,
  MOBILE_VIEWPORT
} from '../constants'
import { TooltipLabel } from 'components/TooltipLabel';

const StyledFormRow = styled.div({
  display: 'grid',
  gridTemplateColumns: '1fr 110px',
  gridGap: 20
})
 
const mobileViewTooltip = "Check this option to do a scan for a mobile device.";
const enableParameterTooltip = "Check this option to allow insert parameters prior each scan to manipulate the outcome. This option will only be enabled if there are parameters to use.";
const rootUrlTooltip = "Enter URL from which the scan will start i.e. https://mywebsite.com. For parameterized scans use: $BASE_ADDRESS.";

const FullScan = ({ getFieldDecorator, simple=true }) => {
  return (
    <>
      <StyledFormRow>
        <Form.Item>
          <TooltipLabel required htmlFor={FULL_SCAN_ROOT_URL_FIELD} value="ROOT URL" tooltip={{hidden: simple, text: rootUrlTooltip}} />
          {getFieldDecorator(FULL_SCAN_ROOT_URL_FIELD, {
            rules: [
              {
                required: true,
                message: 'required'
              }
            ]
          })(<Input placeholder="Root URL"/>)}
        </Form.Item>
        <Form.Item>
          <TooltipLabel required htmlFor={FULL_SCAN_COUNT_FIELD} value="COUNT" tooltip={{hidden: true}} />  
          {getFieldDecorator(FULL_SCAN_COUNT_FIELD, {
            rules: [
              {
                required: true,
                message: 'required'
              }
            ]
          })(<InputNumber min={1} placeholder="Count" />)}
        </Form.Item>
          {!simple && <div className={"advanced"}><Form.Item name="parameters">
            {getFieldDecorator(SCAN_PARAMETERS_FLAG_FIELD, {
                initialValue: false,
                valuePropName: 'checked'
            })( 
              <Checkbox>
                <TooltipLabel htmlFor={SCAN_PARAMETERS_FLAG_FIELD} value="ENABLE PARAMETERS " 
                  tooltip={{text: enableParameterTooltip}} 
                />  
              </Checkbox>
            )}
          </Form.Item>
            <Form.Item>
          {getFieldDecorator(MOBILE_VIEWPORT, {
            initialValue: false,
            valuePropName: 'checked'
          })(<Checkbox><TooltipLabel htmlFor={MOBILE_VIEWPORT} value="MOBILE VIEWPORT"
            tooltip={{text: mobileViewTooltip}}
            /> </Checkbox>)}
            </Form.Item></div>}
      </StyledFormRow>
      {simple && <div>
        <Form.Item>
          {getFieldDecorator(ALL_SUB_DOMAINS_FIELD, {
            initialValue: false,
            valuePropName: 'checked'
          })(<Checkbox>Include all subdomains</Checkbox>)}
        </Form.Item>
      </div>}
    </>
  )
}
export default FullScan
